import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { GlobalVars } from '../../../providers/globalVars';
import { Router } from '@angular/router';
import { AuthData } from '../../../providers/auth-data';
import { TranslateService } from '@ngx-translate/core';
import { AlertController,LoadingController, IonRouterOutlet } from '@ionic/angular';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-chsignin',
  templateUrl: './chsignin.page.html',
  styleUrls: ['./chsignin.page.scss'],
})
export class ChsigninPage implements OnInit {
  public loginForm: any;

  constructor(public fb: FormBuilder,public gv:GlobalVars, public authData: AuthData, private loadCtrl:LoadingController,
   public alertCtrl: AlertController,public translate: TranslateService, public router: Router,
  public outlet:IonRouterOutlet) { 
  let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.loginForm = fb.group({
        email: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
        password: ['', Validators.compose([Validators.minLength(6), Validators.required])]
    })
  }
  ngOnInit() {
  }

  async login(){
    if (!this.loginForm.valid){} 
    else {
    const loadingPopup = await this.loadCtrl.create({
          spinner: 'crescent',
          message: ''
      });
      loadingPopup.present();
    this.authData.loginUser(this.loginForm.value.email, this.loginForm.value.password)
    .then( 
      authData => {
        loadingPopup.dismiss();
        //fcm 아이디
        this.outlet.pop();
        setTimeout(_=> {this.authData.initnotiasdb();}, 1200);
      /*

        //this.scrollToTop();
        firebase.database().ref('/userProfile/'+ authData.uid).once('value').then(data=>{
          if(data.val())
          {
            loadingPopup.dismiss();
            this.router.navigate(['']);
          }
          else
          {
            
          }
        }).then(_=>{
          
        }).catch(_=>{loadingPopup.dismiss();this.router.navigate([''])})
        */
            }, error => {
        loadingPopup.dismiss();
        switch (error.code){
        case "auth/user-not-found":
            var notregisterdemail;
            this.translate.get('Email not registerd yet. Please check it again').subscribe(res=>{
            notregisterdemail = res;
            });
            this.presentAlert(notregisterdemail); break;
        case "auth/wrong-password":
            var pwdnotmatchretry;
            this.translate.get('The password does not match. Please check it again').subscribe(res=>{
            pwdnotmatchretry = res;
            });
            this.presentAlert(pwdnotmatchretry); break;
        case "auth/user-disabled":
            var cantusetheaccount;
            this.translate.get('This account can not use').subscribe(res=>{
            cantusetheaccount = res;
            });
            this.presentAlert(cantusetheaccount); break;
        default :
            var signininfowrong;
            this.translate.get('Sign in information is incorrect').subscribe(res=>{
            signininfowrong = res;
            });
            this.presentAlert(signininfowrong); break;
        }
    });
    }
    }

    async presentAlert(title) {
    var okmsg;
    this.translate.get('Confirm').subscribe(res=>{
    okmsg = res;
    });
    const alert = await this.alertCtrl.create({
      message:title,
      buttons: [okmsg]
    });
    alert.present();
  }

}
